import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { useSelector } from "react-redux";

import { PrivateRouteNew } from "@components";
import { routerPath, APP_STATES } from "@config";
import {
  FormStep1,
  FormStep2,
  FormStep3,
  FormStep4,
  FormStep5,
  FormStep6,
  FormStep7,
  FormStep8
} from "@containers/FormStepper";
import { StepsLayout } from "@layouts/StepsLayout/StepsLayout";
import { selectKycCurrentState } from "@redux";

export const StepperRouter = () => {
  const currentState = useSelector(selectKycCurrentState);

  // flow finished
  if (currentState && currentState !== APP_STATES.USER_FILLING_APPLICATION) {
    return <Redirect to={routerPath.kyc} />;
  }

  return (
    <StepsLayout>
      <Switch>
        <PrivateRouteNew path={routerPath.newKycSme.step1} exact component={() => <FormStep1 />} />
        <PrivateRouteNew path={routerPath.newKycSme.step2} exact component={() => <FormStep2 />} />
        <PrivateRouteNew path={routerPath.newKycSme.step3} exact component={() => <FormStep3 />} />
        <PrivateRouteNew path={routerPath.newKycSme.step4} exact component={() => <FormStep4 />} />
        <PrivateRouteNew path={routerPath.newKycSme.step5} exact component={() => <FormStep5 />} />
        <PrivateRouteNew path={routerPath.newKycSme.step6} exact component={() => <FormStep6 />} />
        <PrivateRouteNew path={routerPath.newKycSme.step7} exact component={() => <FormStep7 />} />
        <PrivateRouteNew path={routerPath.newKycSme.step8} exact component={() => <FormStep8 />} />
      </Switch>
    </StepsLayout>
  );
};
